import { LoadingButton } from '@mui/lab'
import React from 'react'
import { useBoolean } from 'react-use'

import toast from 'lib/toast'
import { messageFromResponseError } from 'utils/strings'

export const ReactivateButton: React.FC<{
  onConfirmRequest(): Promise<unknown>
  onSuccess(): Promise<void>
}> = ({ onConfirmRequest, onSuccess }) => {
  const [isSubmitting, setIsSubmitting] = useBoolean(false)

  const handleClick = async () => {
    setIsSubmitting(true)

    try {
      await onConfirmRequest()

      toast({
        type: 'success',
        text: 'Activation successful'
      })
      setIsSubmitting(false)

      await onSuccess()
    } catch (error) {
      toast({
        type: 'error',
        text: messageFromResponseError(
          error,
          'Activation failed. Please try again later.'
        )
      })
      setIsSubmitting(false)
    }
  }

  return (
    <LoadingButton
      color="primary"
      loading={isSubmitting}
      size="small"
      sx={{ width: 'fit-content' }}
      variant="contained"
      onClick={handleClick}
    >
      Reactivate
    </LoadingButton>
  )
}
